import CryptoJS from "crypto-js";

const secretKey = process.env.REACT_APP_SECRET_KEY;
const APP_ENV = process.env.REACT_APP_ENV;

const base64UrlEncode = (str) => {
  return btoa(str)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}
const base64UrlDecode = (str) => {
  let base64 = str?.replace(/-/g, '+').replace(/_/g, '/');
  while (base64.length % 4) {
    base64 += '=';
  }
  return atob(base64);
}

export const encryptData = (text) => {
  if(APP_ENV==="DEV"){
    return text
  }
  if(text){
    try{
      const encrypted = CryptoJS.AES.encrypt(text, secretKey).toString();
      const urlSafeEncrypted = base64UrlEncode(encrypted);
      return urlSafeEncrypted;
    } catch(err){
      return text
    }
  }
  return text
};

export const decryptData = (encryptedText) => {
  if(APP_ENV==="DEV"){
    return encryptedText
  }
  if (encryptedText) {
    try{
      const decoded = base64UrlDecode(encryptedText);
      const bytes = CryptoJS.AES.decrypt(decoded, secretKey);
      const originalText = bytes.toString(CryptoJS.enc.Utf8);
      return originalText;
    } catch(err){
      return encryptedText
    }
  }
  return encryptedText
};